/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'components/core/icon';

import s from './styles.module.scss';

const createButton = (buttonStyling) => {
  const Button = ({ className, children, onClick, isDisabled = false, type = 'button', ...props }) => (
    <button
      {...props}
      type={type}
      onClick={onClick}
      className={cx(s.button, buttonStyling, className)}
      disabled={isDisabled}
    >
      <span className={s.text}>{children}</span>
    </button>
  );

  Button.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(['submit', 'button']),
    isDisabled: PropTypes.bool,
  };

  return Button;
};

// IconButton component that shows icon first, then text
const IconButton = ({ className, children, onClick, isDisabled = false, type = 'button', icon, ...props }) => (
  <button
    {...props}
    type={type}
    onClick={onClick}
    className={cx(s.button, s.buttonIcon, className)}
    disabled={isDisabled}
  >
    {icon && <Icon icon={icon} className={s.icon} />}
    <span className={s.text}>{children}</span>
  </button>
);

IconButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['submit', 'button']),
  isDisabled: PropTypes.bool,
  icon: PropTypes.oneOf(Object.values(Icon.icons)),
};

export const PrimaryButton = createButton(s.buttonPrimary);
export const Button = createButton(s.buttonSecondary);
export const FlatButton = createButton(s.buttonFlat);
export { IconButton };
